/* Arbuckle Subscribe & Save landing (arb-ss-* sections)
   Builder (variants + Recharge selling plans), filters, details drawer,
   mobile sheet + sticky bar, cart hand-off (Rebuy Smart Cart / theme drawer), reveals. */
(function () {
  'use strict';
  if (window.__arbSS) return;
  window.__arbSS = true;

  var mqDesk = window.matchMedia('(min-width: 990px)');
  var mqReduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var designMode = !!(window.Shopify && window.Shopify.designMode);

  /* ---------------- helpers ---------------- */
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function money(cents, fmt) {
    var n = (Number(cents) || 0) / 100;
    function f(num, dec, ts, ds) {
      var p = num.toFixed(dec).split('.');
      p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ts);
      return p.join(ds);
    }
    return (fmt || '${{amount}}').replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_no_decimals') return f(n, 0, ',', '.');
      if (k === 'amount_with_comma_separator') return f(n, 2, '.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return f(n, 0, '.', ',');
      if (k === 'amount_with_apostrophe_separator') return f(n, 2, "'", '.');
      return f(n, 2, ',', '.');
    });
  }
  function scrollBehavior() { return mqReduce.matches ? 'auto' : 'smooth'; }
  var FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea,[tabindex]:not([tabindex="-1"])';
  function trapTab(container, e) {
    if (e.key !== 'Tab') return;
    var f = $$(FOCUSABLE, container).filter(function (el) { return el.getClientRects().length > 0; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }
  var lockCount = 0;
  function lock(on) {
    lockCount = Math.max(0, lockCount + (on ? 1 : -1));
    document.documentElement.classList.toggle('arb-lock', lockCount > 0);
  }

  /* ---------------- product data helpers ---------------- */
  var GRIND_RE = /whole\s*bean|espresso|auto\s*drip|drip|french\s*press|percolator|camp\s*fire|campfire/i;
  function titleCase(s) { return s.replace(/\b([a-z])/g, function (m) { return m.toUpperCase(); }); }
  // drops "(hints)" and the stray "v" typo in values like "Espresso v(very fine)"
  function cleanValue(v) { return String(v).replace(/\s*\(.*?\)\s*/g, ' ').replace(/\s+/g, ' ').trim().replace(/\s+v$/i, ''); }
  function optKind(opt) {
    if (!opt.values || opt.values.length <= 1) return 'static';
    var g = opt.values.filter(function (v) { return GRIND_RE.test(v); }).length;
    return g >= Math.ceil(opt.values.length / 2) ? 'grind' : 'seg';
  }
  function optLabel(opt, kind) {
    if (kind === 'grind') return 'Grind';
    if (/regular\s+or\s+decaf/i.test(opt.name)) return 'Regular or decaf';
    if (/^quantity$/i.test(opt.name)) return 'Box';
    return String(opt.name).replace(/\?\s*$/, '');
  }
  function grindInfo(v) {
    var hint = (/\(([^)]*)\)/.exec(v) || [])[1] || '';
    hint = hint.trim();
    var name = titleCase(cleanValue(v).toLowerCase()).replace('Campfire/Percolator', 'Campfire & Percolator').replace(/\bAutodrip\b/, 'Autodrip');
    var icon = 'bean';
    if (/espresso/i.test(name)) icon = 'espresso';
    else if (/drip/i.test(name)) icon = 'drip';
    else if (/french|press/i.test(name)) icon = 'press';
    else if (/camp/i.test(name)) icon = 'flame';
    else if (/percol/i.test(name)) icon = 'percolator';
    if (!hint && /whole/i.test(name)) hint = 'Not ground';
    return { name: name, hint: hint, icon: icon };
  }
  function groupValues(values, kind) {
    var out = [], idx = {};
    values.forEach(function (v) {
      var label = kind === 'grind' ? grindInfo(v).name : cleanValue(v);
      var key = label.toLowerCase();
      if (idx[key] == null) { idx[key] = out.length; out.push({ key: key, label: label, raws: [v], info: kind === 'grind' ? grindInfo(v) : null }); }
      else out[idx[key]].raws.push(v);
    });
    return out;
  }
  function parseInterval(plan) {
    var src = (plan.o || []).concat([plan.name || '']);
    for (var i = 0; i < src.length; i++) {
      var m = /(\d+)\s*-?\s*(day|week|month)/i.exec(String(src[i]));
      if (m) {
        var n = +m[1], u = m[2].toLowerCase();
        return { n: n, u: u, days: n * (u === 'day' ? 1 : u === 'week' ? 7 : 30) };
      }
    }
    return null;
  }
  function intervalLabel(iv) { return iv.n + ' ' + iv.u + (iv.n === 1 ? '' : 's'); }
  function cleanDesc(html) {
    var doc = new DOMParser().parseFromString('<div>' + (html || '') + '</div>', 'text/html');
    var root = doc.body.firstElementChild;
    $$('iframe,img,script,style,video,object,embed,meta,link,form,input,button', root).forEach(function (e) { e.remove(); });
    $$('*', root).forEach(function (e) {
      Array.prototype.slice.call(e.attributes).forEach(function (a) {
        if (a.name !== 'href') e.removeAttribute(a.name);
      });
      if (e.tagName === 'A') {
        var h = e.getAttribute('href') || '';
        if (!/^(https?:|\/)/i.test(h)) e.removeAttribute('href');
      }
    });
    var walker = doc.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var node, emoji;
    try { emoji = new RegExp('[\\u{1F300}-\\u{1FAFF}\\u{2600}-\\u{27BF}\\u{FE0F}]', 'gu'); } catch (e) { emoji = null; }
    while ((node = walker.nextNode())) {
      var t = node.nodeValue.replace(/\*\*/g, '');
      if (emoji) t = t.replace(emoji, '');
      node.nodeValue = t;
    }
    Array.prototype.slice.call(root.children).forEach(function (el) {
      var t = (el.textContent || '').replace(/ /g, ' ').trim();
      if (!t) { el.remove(); return; }
      if (/\S\s{3,}\S/.test(t) && t.length < 100) el.remove();
    });
    // unwrap stray divs into paragraphs
    $$('div', root).forEach(function (d) { var p = doc.createElement('p'); p.innerHTML = d.innerHTML; d.replaceWith(p); });
    return root.innerHTML;
  }

  /* ---------------- top offset (sticky theme header awareness) ---------------- */
  var topOffset = -1;
  function measureTop() {
    var max = 0;
    $$('sticky-header, .shopify-section-group-header-group, .section-header, .header-wrapper').forEach(function (el) {
      var cs = getComputedStyle(el);
      if (cs.position !== 'sticky' && cs.position !== 'fixed') return;
      var r = el.getBoundingClientRect();
      if (r.height > 0 && r.top <= 1 && r.bottom > 0 && r.bottom < window.innerHeight * 0.4) max = Math.max(max, r.bottom);
    });
    max = Math.round(max);
    if (max !== topOffset) {
      topOffset = max;
      $$('.arb').forEach(function (el) { el.style.setProperty('--arb-top', max + 'px'); });
    }
  }

  /* ---------------- reveal ---------------- */
  var io = null;
  function initReveal(scope) {
    var els = $$('[data-arb-reveal]', scope || document);
    if (designMode || mqReduce.matches || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    if (!io) {
      document.documentElement.classList.add('arb-reveal-on');
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            var el = e.target;
            el.classList.add('is-in');
            io.unobserve(el);
            // hand transitions back to the component (hover lift etc.) once the one-shot reveal is done
            setTimeout(function () { el.removeAttribute('data-arb-reveal'); el.style.removeProperty('--arb-delay'); }, 900);
          }
        });
      }, { rootMargin: '0px 0px -6% 0px', threshold: 0.06 });
    }
    els.forEach(function (el) {
      var sibs = el.parentElement ? $$(':scope > [data-arb-reveal]', el.parentElement) : [el];
      var i = sibs.indexOf(el);
      el.style.setProperty('--arb-delay', Math.min(i % 4, 3) * 70 + 'ms');
      io.observe(el);
    });
  }

  /* ---------------- Shop ---------------- */
  var shops = [];

  function Shop(root) {
    this.root = root;
    this.sid = root.getAttribute('data-section');
    this.fmt = root.getAttribute('data-money') || '${{amount}}';
    this.defaultWeeks = parseInt(root.getAttribute('data-interval'), 10) || 4;
    this.defaultQty = Math.min(99, Math.max(1, parseInt(root.getAttribute('data-qty'), 10) || 1));
    this.labels = {
      add: root.getAttribute('data-label-add') || 'Add to cart',
      select: root.getAttribute('data-label-select') || 'Select',
      selected: root.getAttribute('data-label-selected') || 'Selected'
    };
    var raw = $('[data-arb-data]', root);
    try { this.products = JSON.parse(raw ? raw.textContent : '[]'); } catch (e) { this.products = []; console.error('arb-ss: product data', e); }
    this.byHandle = {};
    var self = this;
    this.products.forEach(function (p) { self.byHandle[p.handle] = p; });
    this.icons = {};
    var tpl = $('template[data-arb-icons]', root);
    if (tpl) $$('[data-icon]', tpl.content).forEach(function (s) { self.icons[s.getAttribute('data-icon')] = s.innerHTML; });

    this.builder = $('[data-arb-builder]', root);
    this.drawer = $('[data-arb-drawer]', root);
    this.bar = $('[data-arb-bar]', root);
    this.cards = $$('[data-arb-card]', root);
    this.state = { tab: 'all', decaf: false, mode: 'sub', days: this.defaultWeeks * 7, qty: this.defaultQty };
    this.userPicked = false;
    this.sheetOpen = false;
    this.drawerOpen = false;

    if (!this.builder || !this.products.length) return;
    this.bindFilters();
    this.bindCards();
    this.bindBuilder();
    this.bindDrawer();
    this.bindBar();
    var start = root.getAttribute('data-default');
    this.select(this.byHandle[start] ? start : this.products[0].handle, { silent: true });
    this.watchSticky();
  }

  /* ---- filters ---- */
  Shop.prototype.bindFilters = function () {
    var self = this;
    $$('[data-arb-tab]', this.root).forEach(function (b) {
      b.addEventListener('click', function () {
        self.state.tab = b.getAttribute('data-arb-tab');
        $$('[data-arb-tab]', self.root).forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
        self.applyFilter(true);
      });
    });
    var d = $('[data-arb-decaf]', this.root);
    if (d) d.addEventListener('click', function () {
      self.state.decaf = !self.state.decaf;
      d.setAttribute('aria-pressed', String(self.state.decaf));
      self.applyFilter(true);
    });
  };
  Shop.prototype.applyFilter = function (keepTop) {
    var st = this.state, shown = {}, any = false;
    this.cards.forEach(function (c) {
      var ok = (st.tab === 'all' || c.getAttribute('data-group') === st.tab) && (!st.decaf || c.getAttribute('data-decaf') === 'true');
      c.hidden = !ok;
      if (ok) { shown[c.getAttribute('data-group')] = true; any = true; c.classList.add('is-in'); }
    });
    $$('[data-arb-ghead]', this.root).forEach(function (h) {
      h.hidden = !(st.tab === 'all' && shown[h.getAttribute('data-arb-ghead')]);
    });
    var empty = $('[data-arb-empty]', this.root);
    if (empty) empty.hidden = any;
    if (keepTop) {
      var f = $('[data-arb-filter]', this.root);
      var r = f.getBoundingClientRect();
      if (r.top < (topOffset > 0 ? topOffset : 0) - 2 || r.top < 0) {
        window.scrollTo({ top: window.pageYOffset + r.top - (topOffset > 0 ? topOffset : 0) - 12, behavior: 'auto' });
      }
    }
  };

  /* ---- cards ---- */
  Shop.prototype.bindCards = function () {
    var self = this;
    this.cards.forEach(function (card) {
      var h = card.getAttribute('data-handle');
      $$('[data-arb-select]', card).forEach(function (a) {
        a.addEventListener('click', function (e) {
          if (!self.byHandle[h]) return;
          e.preventDefault();
          self.select(h, { user: true, trigger: a });
        });
      });
      $$('[data-arb-details]', card).forEach(function (a) {
        a.addEventListener('click', function (e) {
          if (!self.byHandle[h]) return;
          e.preventDefault();
          self.openDrawer(h, a);
        });
      });
    });
  };
  Shop.prototype.markCards = function () {
    var h = this.p.handle, L = this.labels;
    this.cards.forEach(function (c) {
      var on = c.getAttribute('data-handle') === h;
      c.classList.toggle('is-selected', on);
      var lab = $('[data-arb-select-label]', c);
      if (lab) lab.textContent = on ? L.selected : L.select;
    });
  };

  /* ---- selection ---- */
  Shop.prototype.select = function (handle, opts) {
    opts = opts || {};
    var p = this.byHandle[handle];
    if (!p) return;
    var same = this.p && this.p.handle === handle;
    this.p = p;
    if (!same) {
      // a different coffee starts fresh: first available variant + the default bag count;
      // re-selecting the current coffee keeps its grind and quantity
      var v = p.variants.filter(function (x) { return x.a; })[0] || p.variants[0];
      this.v = v;
      this.sel = v.o.slice();
      this.state.qty = this.defaultQty;
    }
    if (p.reqPlan) this.state.mode = 'sub';
    if (opts.user) this.userPicked = true;
    this.renderHead();
    this.render();
    this.markCards();
    if (opts.silent) return;
    if (mqDesk.matches) {
      var b = this.builder;
      b.classList.remove('is-flash'); void b.offsetWidth; b.classList.add('is-flash');
      if (opts.scroll) {
        var lay = $('.arb-shop__layout', this.root);
        var r = lay.getBoundingClientRect();
        if (r.top > window.innerHeight * 0.3 || r.bottom < window.innerHeight * 0.5) {
          window.scrollTo({ top: window.pageYOffset + r.top - (topOffset > 0 ? topOffset : 0) - 16, behavior: scrollBehavior() });
        }
      }
    } else {
      this.openSheet(opts.trigger);
    }
    this.updateBar();
  };

  Shop.prototype.currentVariant = function () {
    var sel = this.sel;
    return this.p.variants.filter(function (v) { return v.o.every(function (x, i) { return x === sel[i]; }); })[0] || null;
  };
  Shop.prototype.resolve = function (idx) {
    var exact = this.currentVariant();
    if (exact) { this.v = exact; return; }
    var sel = this.sel;
    var cands = this.p.variants.filter(function (v) { return v.o[idx] === sel[idx]; });
    cands.sort(function (a, b) {
      // exact value match scores 1; same value with different spelling/case ("Whole bean" vs "Whole Bean") scores 0.9
      function norm(x) { return cleanValue(x).toLowerCase(); }
      function score(v) { var s = 0; v.o.forEach(function (x, i) { if (x === sel[i]) s += 1; else if (norm(x) === norm(sel[i])) s += 0.9; }); return s + (v.a ? 0.05 : 0); }
      return score(b) - score(a);
    });
    this.v = cands[0] || this.p.variants[0];
    this.sel = this.v.o.slice();
  };

  Shop.prototype.plansFor = function (v) {
    var p = this.p;
    return (p.plans || []).filter(function (pl) { return v.sp && v.sp[String(pl.id)] != null; })
      .map(function (pl) { return { id: pl.id, iv: parseInterval(pl), price: v.sp[String(pl.id)] }; })
      .filter(function (x) { return x.iv; })
      .sort(function (a, b) { return a.iv.days - b.iv.days; });
  };

  /* ---- render ---- */
  Shop.prototype.renderHead = function () {
    var p = this.p, b = this.builder;
    var img = $('[data-arb-b-img]', b);
    if (p.thumb) { img.src = p.thumb; img.alt = ''; }
    $('[data-arb-b-title]', b).textContent = p.title;
    var bits = [];
    if (p.flag) bits.push(p.flag);
    p.options.forEach(function (o) { if (optKind(o) === 'static') bits.push(String(o.values[0]).replace(/(\d)\s?oz\b/i, '$1 oz')); });
    $('[data-arb-b-sub]', b).innerHTML = bits.map(esc).join(' &middot; ') || '&nbsp;';
  };

  Shop.prototype.render = function () {
    var self = this, p = this.p, b = this.builder, sid = this.sid;
    var html = '';
    p.options.forEach(function (opt, i) {
      var kind = optKind(opt);
      if (kind === 'static') return;
      var groups = groupValues(opt.values, kind);
      var cur = self.sel[i];
      var curG = groups.filter(function (g) { return g.raws.indexOf(cur) > -1; })[0] || groups[0];
      var lid = 'arb-ol-' + sid + '-' + i;
      html += '<div class="arb-opt"><p class="arb-opt__label" id="' + lid + '">' + esc(optLabel(opt, kind)) + ' <span>' + esc(curG.label) + '</span></p>';
      var cols = groups.length === 4 ? 2 : Math.min(3, groups.length);
      html += kind === 'grind'
        ? '<div class="arb-grind" role="radiogroup" aria-labelledby="' + lid + '" style="grid-template-columns:repeat(' + cols + ',minmax(0,1fr))">'
        : '<div class="arb-seg" role="radiogroup" aria-labelledby="' + lid + '">';
      groups.forEach(function (g) {
        // choose the raw value that fits the other selections
        var raw = g.raws[0];
        var test = self.sel.slice();
        for (var k = 0; k < g.raws.length; k++) {
          test[i] = g.raws[k];
          if (self.p.variants.some(function (v) { return v.o.every(function (x, j) { return x === test[j]; }); })) { raw = g.raws[k]; break; }
        }
        var avail = self.p.variants.some(function (v) { return v.a && g.raws.indexOf(v.o[i]) > -1; });
        var checked = g === curG;
        var name = 'arb-o-' + sid + '-' + i;
        var input = '<input type="radio" name="' + name + '" value="' + esc(raw) + '" data-opt="' + i + '"' + (checked ? ' checked' : '') + (avail ? '' : ' disabled') + ' aria-label="' + esc(g.label) + (avail ? '' : ' (sold out)') + '">';
        if (kind === 'grind') {
          html += '<label class="arb-grind__opt">' + input + '<span class="arb-grind__tile" aria-hidden="true">' + (self.icons[g.info.icon] || '') +
            '<span class="arb-grind__name">' + esc(g.info.name) + '</span>' + (g.info.hint ? '<span class="arb-grind__hint">' + esc(g.info.hint) + '</span>' : '') + '</span></label>';
        } else {
          var sub = '';
          if (/size|pound|oz|lb/i.test(opt.name + ' ' + g.label)) {
            var t2 = self.sel.slice(); t2[i] = raw;
            var vv = self.p.variants.filter(function (v) { return v.o.every(function (x, j) { return x === t2[j]; }); })[0];
            if (vv) sub = money(self.unitPrice(vv), self.fmt);
          }
          html += '<label class="arb-seg__opt">' + input + '<span class="arb-seg__btn" aria-hidden="true"><span class="arb-seg__t">' + esc(g.label) + '</span>' + (sub ? '<span class="arb-seg__s">' + esc(sub) + '</span>' : '') + '</span></label>';
        }
      });
      html += '</div></div>';
    });
    var optsEl = $('[data-arb-b-opts]', b);
    optsEl.innerHTML = html;
    optsEl.hidden = !html;
    $$('input[data-opt]', optsEl).forEach(function (inp) {
      inp.addEventListener('change', function () {
        var i = +inp.getAttribute('data-opt');
        self.sel[i] = inp.value;
        self.resolve(i);
        self.render();
        var again = $('input[data-opt="' + i + '"]:checked', optsEl);
        if (again) again.focus({ preventScroll: true });
      });
    });
    this.renderPlans();
    this.renderPrice();
  };

  Shop.prototype.unitPrice = function (v) {
    if (this.state.mode === 'sub') {
      var pl = this.pickPlan(v);
      if (pl) return pl.price;
    }
    return v.p;
  };
  Shop.prototype.pickPlan = function (v) {
    var plans = this.plansFor(v), days = this.state.days;
    if (!plans.length) return null;
    var best = plans[0];
    plans.forEach(function (x) { if (Math.abs(x.iv.days - days) < Math.abs(best.iv.days - days)) best = x; });
    return best;
  };

  Shop.prototype.renderPlans = function () {
    var self = this, b = this.builder, v = this.v, p = this.p;
    var plans = this.plansFor(v);
    var subCard = $('[data-arb-mode-card="sub"]', b);
    var onceCard = $('[data-arb-mode-card="once"]', b);
    if (!plans.length) this.state.mode = 'once';
    if (p.reqPlan && plans.length) this.state.mode = 'sub';
    if (!onceCard && plans.length) this.state.mode = 'sub';
    subCard.hidden = !plans.length;
    if (onceCard) onceCard.hidden = !!p.reqPlan;
    var mode = this.state.mode;
    subCard.classList.toggle('is-on', mode === 'sub');
    if (onceCard) onceCard.classList.toggle('is-on', mode === 'once');
    $$('[data-arb-mode]', b).forEach(function (r) { r.checked = r.value === mode; });

    var cur = this.pickPlan(v);
    var freq = $('[data-arb-b-freq]', b);
    var name = 'arb-f-' + this.sid;
    freq.innerHTML = plans.map(function (pl) {
      var on = cur && pl.id === cur.id;
      return '<label class="arb-seg__opt"><input type="radio" name="' + name + '" value="' + pl.iv.days + '"' + (on ? ' checked' : '') + ' aria-label="Every ' + esc(intervalLabel(pl.iv)) + '"' + (mode === 'sub' ? '' : ' tabindex="-1"') + '><span class="arb-seg__btn" aria-hidden="true"><span class="arb-seg__t">' + esc(intervalLabel(pl.iv)) + '</span></span></label>';
    }).join('');
    $$('input', freq).forEach(function (inp) {
      inp.addEventListener('change', function () {
        self.state.days = +inp.value;
        self.renderPrice();
        self.updateBar();
      });
    });
  };

  Shop.prototype.renderPrice = function () {
    var b = this.builder, v = this.v, p = this.p, st = this.state, fmt = this.fmt;
    var plan = this.pickPlan(v);
    var base = v.p;
    var subP = plan ? plan.price : base;
    var saving = Math.max(0, base - subP);
    var pct = base > 0 ? Math.round(saving / base * 100) : 0;
    // option prices are totals for the chosen quantity; the per-unit price sits underneath
    var q = st.qty;
    var unitWord = p.unit === 'box' ? 'box' : 'bag';
    $('[data-arb-b-subprice]', b).textContent = money(subP * q, fmt);
    var was = $('[data-arb-b-subwas]', b);
    was.textContent = saving > 0 ? money(base * q, fmt) : '';
    was.hidden = saving <= 0;
    $$('[data-arb-b-unit]', b).forEach(function (el) {
      var unit = el.getAttribute('data-arb-b-unit') === 'sub' ? subP : base;
      el.textContent = money(unit, fmt) + '/' + unitWord;
      el.hidden = q <= 1;
    });
    var chip = $('[data-arb-b-pct]', b);
    chip.textContent = 'Save ' + pct + '%';
    chip.hidden = pct <= 0;
    var subName = $('[data-arb-b-subname]', b);
    if (!subName.getAttribute('data-default')) subName.setAttribute('data-default', subName.textContent);
    subName.textContent = pct > 0 ? subName.getAttribute('data-default') : 'Subscribe';
    var once = $('[data-arb-b-onceprice]', b);
    if (once) once.textContent = money(base * q, fmt);

    // frequency selection follows the plan actually picked
    if (plan) {
      $$('[data-arb-b-freq] input', b).forEach(function (r) { r.checked = +r.value === plan.iv.days; });
      var d = new Date(); d.setDate(d.getDate() + plan.iv.days);
      var ds = d.toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
      $('[data-arb-b-next-t]', b).innerHTML = 'Next order around <b>' + esc(ds) + '</b>, then every ' + esc(intervalLabel(plan.iv)) + '.';
    }

    var unit = st.mode === 'sub' && plan ? subP : base;
    var qty = st.qty;
    var noun = p.unit === 'box' ? (qty === 1 ? 'box' : 'boxes') : (qty === 1 ? 'bag' : 'bags');
    $('[data-arb-b-qty]', b).textContent = qty + ' ' + noun;
    $('[data-arb-qty="-1"]', b).disabled = qty <= 1;
    $('[data-arb-qty="1"]', b).disabled = qty >= 99;

    var add = $('[data-arb-add]', b);
    if (!add.classList.contains('is-busy') && !add.classList.contains('is-done')) {
      $('[data-arb-add-label]', add).textContent = v.a ? this.labels.add : 'Sold out';
      $('[data-arb-add-price]', add).textContent = money(unit * qty, fmt);
    }
    add.disabled = !v.a;

    var note = $('[data-arb-b-note]', b);
    if (st.mode === 'sub' && plan && saving > 0) {
      var per = saving * qty;
      var deliveries = Math.floor(363 / plan.iv.days) + 1;
      note.innerHTML = 'You save <b>' + esc(money(per, fmt)) + '</b> per delivery, <b>' + esc(money(per * deliveries, fmt)) + '</b> over your first year.';
    } else if (st.mode === 'once') {
      var bestSave = 0;
      this.plansFor(v).forEach(function (x) { bestSave = Math.max(bestSave, v.p - x.price); });
      note.innerHTML = bestSave > 0
        ? 'Subscribe instead and save <b>' + esc(money(bestSave * qty, fmt)) + '</b>. <button type="button" data-arb-switch>Switch</button>'
        : '&nbsp;';
      var sw = $('[data-arb-switch]', note);
      var self = this;
      if (sw) sw.addEventListener('click', function () { self.setMode('sub'); });
    } else {
      note.innerHTML = 'Skip, pause or change anytime.';
    }
    this.updateBar();
  };

  Shop.prototype.setMode = function (m) {
    this.state.mode = m;
    this.renderPlans();
    this.renderPrice();
  };

  /* ---- builder events ---- */
  Shop.prototype.bindBuilder = function () {
    var self = this, b = this.builder;
    $$('[data-arb-mode]', b).forEach(function (r) {
      r.addEventListener('change', function () { if (r.checked) self.setMode(r.value); });
    });
    $$('[data-arb-qty]', b).forEach(function (btn) {
      btn.addEventListener('click', function () {
        self.state.qty = Math.min(99, Math.max(1, self.state.qty + (+btn.getAttribute('data-arb-qty'))));
        self.renderPrice();
      });
    });
    $('[data-arb-add]', b).addEventListener('click', function () { self.add(); });
    var viewCart = $('[data-arb-viewcart]', b);
    if (viewCart) viewCart.addEventListener('click', function (e) {
      // open the cart drawer in place; without one, the link falls through to the cart page
      if (!hasCartDrawer()) return;
      e.preventDefault();
      if (self.sheetOpen) self.closeSheet(true);
      showCartDrawer();
    });
    $('[data-arb-b-about]', b).addEventListener('click', function (e) { self.openDrawer(self.p.handle, e.currentTarget, true); });
    $$('[data-arb-close]', b).forEach(function (x) { x.addEventListener('click', function () { self.closeSheet(); }); });
    b.addEventListener('keydown', function (e) {
      if (!self.sheetOpen) return;
      if (e.key === 'Escape') { e.preventDefault(); self.closeSheet(); }
      else trapTab($('[data-arb-panel]', b), e);
    });
    var onMq = function () { if (mqDesk.matches && self.sheetOpen) self.closeSheet(true); self.updateBar(); };
    if (mqDesk.addEventListener) mqDesk.addEventListener('change', onMq); else mqDesk.addListener(onMq);
  };

  Shop.prototype.openSheet = function (trigger) {
    if (mqDesk.matches || this.sheetOpen) return;
    var b = this.builder, panel = $('[data-arb-panel]', b);
    this.sheetOpen = true;
    this.sheetTrigger = trigger || document.activeElement;
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-modal', 'true');
    panel.setAttribute('aria-label', b.getAttribute('aria-label') || 'Your subscription');
    b.classList.add('is-open');
    lock(true);
    $('[data-arb-b-body]', b).scrollTop = 0;
    // focus the sheet itself (screen readers land in the dialog; no focus ring flashes on the close button for taps)
    setTimeout(function () { if (panel) panel.focus({ preventScroll: true }); }, 60);
    this.updateBar();
  };
  Shop.prototype.closeSheet = function (silent) {
    if (!this.sheetOpen) return;
    var b = this.builder, panel = $('[data-arb-panel]', b);
    this.sheetOpen = false;
    b.classList.remove('is-open');
    panel.removeAttribute('role');
    panel.removeAttribute('aria-modal');
    panel.removeAttribute('aria-label');
    lock(false);
    if (!silent && this.sheetTrigger && this.sheetTrigger.focus) this.sheetTrigger.focus({ preventScroll: true });
    this.updateBar();
  };

  /* ---- add to cart ---- */
  Shop.prototype.add = function () {
    var self = this, b = this.builder, v = this.v, st = this.state;
    var btn = $('[data-arb-add]', b);
    if (!v || !v.a || btn.classList.contains('is-busy')) return;
    var plan = st.mode === 'sub' ? this.pickPlan(v) : null;
    var item = { id: v.id, quantity: st.qty };
    if (plan) item.selling_plan = plan.id;
    var label = $('[data-arb-add-label]', btn), price = $('[data-arb-add-price]', btn), live = $('[data-arb-live]', b);
    btn.classList.add('is-busy');
    btn.setAttribute('aria-busy', 'true');
    label.textContent = 'Adding…';
    var err = $('.arb-builder__err', b); if (err) err.remove();
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [item], sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname })
    }).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Could not add to cart'); return j; });
    }).then(function (json) {
      btn.classList.remove('is-busy');
      btn.removeAttribute('aria-busy');
      btn.classList.add('is-done');
      label.textContent = 'Added to cart';
      price.innerHTML = self.icons.check ? '<span style="display:inline-block;width:20px;height:20px">' + self.icons.check + '</span>' : '';
      live.textContent = self.p.title + ' added to cart.';
      setTimeout(function () { btn.classList.remove('is-done'); self.renderPrice(); }, 2400);
      if (self.sheetOpen) self.closeSheet(true);
      openCart(json);
    }).catch(function (e) {
      btn.classList.remove('is-busy');
      btn.removeAttribute('aria-busy');
      self.renderPrice();
      var p = document.createElement('p');
      p.className = 'arb-builder__err';
      p.setAttribute('role', 'alert');
      p.textContent = e.message || 'Something went wrong. Please try again.';
      $('.arb-builder__foot', b).appendChild(p);
    });
  };

  function hasCartDrawer() {
    var R = window.Rebuy;
    if (R && R.SmartCart && typeof R.SmartCart.show === 'function') return true;
    var d = document.querySelector('cart-drawer');
    return !!(d && typeof d.open === 'function' && document.getElementById('CartDrawer'));
  }
  function showCartDrawer() {
    var R = window.Rebuy;
    if (R && R.SmartCart && typeof R.SmartCart.show === 'function') {
      var f = null;
      try { if (R.Cart && typeof R.Cart.fetchCart === 'function') f = R.Cart.fetchCart(); } catch (e) {}
      Promise.resolve(f).catch(function () {}).then(function () { try { R.SmartCart.show(); } catch (e) {} });
      return;
    }
    var d = document.querySelector('cart-drawer');
    if (d && typeof d.open === 'function') d.open();
  }

  function openCart(json) {
    try { document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { source: 'arb-ss' } })); } catch (e) {}
    var R = window.Rebuy;
    if (R && R.SmartCart && typeof R.SmartCart.show === 'function') {
      var f = null;
      try { if (R.Cart && typeof R.Cart.fetchCart === 'function') f = R.Cart.fetchCart(); } catch (e) {}
      Promise.resolve(f).catch(function () {}).then(function () { try { R.SmartCart.show(); } catch (e) {} });
      return;
    }
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.renderContents === 'function' && json && json.sections && json.sections['cart-drawer']) {
      try {
        json.id = json.items && json.items[0] ? json.items[0].id : null;
        drawer.renderContents(json);
        return;
      } catch (e) {}
    }
    window.location.href = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart';
  }

  /* ---- details drawer ---- */
  Shop.prototype.bindDrawer = function () {
    var self = this, d = this.drawer;
    if (!d) return;
    $$('[data-arb-dclose]', d).forEach(function (x) { x.addEventListener('click', function () { self.closeDrawer(); }); });
    d.addEventListener('keydown', function (e) {
      if (!self.drawerOpen) return;
      if (e.key === 'Escape') { e.preventDefault(); self.closeDrawer(); }
      else trapTab($('.arb-drawer__panel', d), e);
    });
    $('[data-arb-d-pick]', d).addEventListener('click', function () {
      var h = self.drawerHandle, fromBuilder = self.drawerFromBuilder;
      self.closeDrawer(true);
      if (fromBuilder && self.p && self.p.handle === h) {
        if (!mqDesk.matches) self.openSheet();
        return;
      }
      self.select(h, { user: true });
    });
    var gal = $('[data-arb-d-gallery]', d);
    var raf = 0;
    gal.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var i = Math.round(gal.scrollLeft / Math.max(1, gal.clientWidth));
        $$('.arb-drawer__thumb', d).forEach(function (t, k) { t.setAttribute('aria-current', String(k === i)); });
      });
    }, { passive: true });
  };
  Shop.prototype.openDrawer = function (handle, trigger, fromBuilder) {
    var p = this.byHandle[handle], d = this.drawer;
    if (!p || !d) return;
    this.drawerHandle = handle;
    this.drawerFromBuilder = !!fromBuilder;
    this.drawerTrigger = trigger || document.activeElement;
    $('[data-arb-d-group]', d).textContent = p.flag || '';
    $('[data-arb-d-title]', d).textContent = p.title;
    var imgs = (p.images && p.images.length) ? p.images : (p.img ? [{ src: p.img, thumb: p.thumb, w: 3, h: 2, alt: p.title }] : []);
    $('[data-arb-d-gallery]', d).innerHTML = imgs.map(function (im, i) {
      var photo = im.h > im.w;
      return '<div class="arb-drawer__shot' + (photo ? ' arb-drawer__shot--photo' : '') + '"><img src="' + esc(im.src) + '" alt="' + esc(im.alt || p.title) + '" width="' + (im.w || 3) + '" height="' + (im.h || 2) + '"' + (i ? ' loading="lazy"' : '') + '></div>';
    }).join('');
    $('[data-arb-d-gallery]', d).scrollLeft = 0;
    var thumbs = $('[data-arb-d-thumbs]', d);
    thumbs.innerHTML = imgs.length > 1 ? imgs.map(function (im, i) {
      return '<button type="button" class="arb-drawer__thumb" aria-label="Show photo ' + (i + 1) + '" aria-current="' + (i === 0) + '" data-i="' + i + '"><img src="' + esc(im.thumb || im.src) + '" alt="" width="60" height="46"></button>';
    }).join('') : '';
    thumbs.hidden = imgs.length < 2;
    $$('.arb-drawer__thumb', thumbs).forEach(function (t) {
      t.addEventListener('click', function () {
        var g = $('[data-arb-d-gallery]', d);
        g.scrollTo({ left: g.clientWidth * +t.getAttribute('data-i'), behavior: scrollBehavior() });
      });
    });
    var card = $('[data-arb-card][data-handle="' + handle + '"] .arb-stars', this.root);
    var rating = $('[data-arb-d-rating]', d);
    rating.innerHTML = card ? card.outerHTML : '';
    rating.hidden = !card;
    var notes = (p.notes || '').split(' · ').filter(Boolean);
    var nEl = $('[data-arb-d-notes]', d);
    nEl.innerHTML = notes.map(function (n) { return '<span class="arb-drawer__note">' + esc(n) + '</span>'; }).join('');
    nEl.hidden = !notes.length;
    var desc = cleanDesc(p.desc);
    var dEl = $('[data-arb-d-desc]', d);
    dEl.innerHTML = desc;
    dEl.hidden = !desc;
    $('[data-arb-d-link]', d).href = p.url;
    $('.arb-drawer__scroll', d).scrollTop = 0;
    var pick = $('[data-arb-d-pick]', d);
    pick.textContent = pick.getAttribute('data-label') || pick.textContent;
    pick.setAttribute('data-label', pick.textContent);
    if (fromBuilder && mqDesk.matches) pick.textContent = 'Back to my subscription';
    if (this.sheetOpen) this.closeSheet(true);
    d.classList.add('is-open');
    this.drawerOpen = true;
    lock(true);
    setTimeout(function () { var dp = $('.arb-drawer__panel', d); if (dp) dp.focus({ preventScroll: true }); }, 60);
    this.updateBar();
  };
  Shop.prototype.closeDrawer = function (silent) {
    if (!this.drawerOpen) return;
    this.drawer.classList.remove('is-open');
    this.drawerOpen = false;
    lock(false);
    var pick = $('[data-arb-d-pick]', this.drawer);
    if (pick.getAttribute('data-label')) pick.textContent = pick.getAttribute('data-label');
    if (!silent && this.drawerTrigger && this.drawerTrigger.focus) this.drawerTrigger.focus({ preventScroll: true });
    this.updateBar();
  };

  /* ---- desktop rail: full-height sticky panel (no inner scrollbar) ---- */
  Shop.prototype.updateSticky = function () {
    var b = this.builder;
    if (!b) return;
    if (!mqDesk.matches) { b.style.removeProperty('--arb-sticky-top'); return; }
    var panel = $('[data-arb-panel]', b);
    var gap = 16;
    var top = (topOffset > 0 ? topOffset : 0) + gap;
    // a panel taller than the screen pins by its bottom edge (negative top), so Add to cart stays reachable
    var fit = window.innerHeight - panel.offsetHeight - gap;
    var val = Math.round(Math.min(top, fit)) + 'px';
    if (b.style.getPropertyValue('--arb-sticky-top') !== val) b.style.setProperty('--arb-sticky-top', val);
  };
  Shop.prototype.watchSticky = function () {
    var self = this, panel = $('[data-arb-panel]', this.builder);
    if (!panel) return;
    if ('ResizeObserver' in window) new ResizeObserver(function () { self.updateSticky(); }).observe(panel);
    window.addEventListener('resize', function () { self.updateSticky(); }, { passive: true });
    this.updateSticky();
  };

  /* ---- mobile sticky bar ---- */
  Shop.prototype.bindBar = function () {
    var self = this, bar = this.bar;
    if (!bar) return;
    var goBtn = $('[data-arb-bar-go]', bar);
    goBtn.setAttribute('data-review', goBtn.textContent.trim());
    goBtn.addEventListener('click', function () {
      if (self.userPicked) self.openSheet(this);
      else {
        var r = self.root.getBoundingClientRect();
        window.scrollTo({ top: window.pageYOffset + r.top - (topOffset > 0 ? topOffset : 0), behavior: scrollBehavior() });
      }
    });
  };
  Shop.prototype.updateBar = function () {
    var bar = this.bar;
    if (!bar || !this.p) return;
    var show = false;
    if (!mqDesk.matches && !this.sheetOpen && !this.drawerOpen && lockCount === 0) {
      var vh = window.innerHeight, r = this.root.getBoundingClientRect();
      var doc = document.documentElement;
      var nearEnd = doc.scrollHeight - (window.pageYOffset + vh) < 360;
      var finalCta = $$('.arb-cta').some(function (el) { var q = el.getBoundingClientRect(); return q.top < vh && q.bottom > 0; });
      var inShop = r.top < vh * 0.5 && r.bottom > vh * 0.5;
      var past = window.pageYOffset > 420;
      if (this.userPicked) show = past && !nearEnd && !finalCta;
      else show = past && !inShop && r.top < vh && !nearEnd && !finalCta;
    }
    if (show) {
      var p = this.p, v = this.v, plan = this.state.mode === 'sub' ? this.pickPlan(v) : null;
      var img = $('[data-arb-bar-img]', bar);
      var t = $('[data-arb-bar-t]', bar), s = $('[data-arb-bar-s]', bar), go = $('[data-arb-bar-go]', bar);
      if (this.userPicked) {
        img.parentElement.hidden = false;
        if (img.getAttribute('src') !== p.thumb) img.src = p.thumb;
        t.textContent = p.title;
        var price = money((plan ? plan.price : v.p) * this.state.qty, this.fmt);
        s.textContent = (plan ? 'Every ' + intervalLabel(plan.iv) : 'One-time') + ' · ' + price;
        go.textContent = go.getAttribute('data-review');
      } else {
        img.parentElement.hidden = true;
        t.textContent = 'Build your subscription';
        s.textContent = 'Pick a coffee, grind and schedule';
        go.textContent = 'Start';
      }
    }
    bar.classList.toggle('is-on', show);
    bar.setAttribute('aria-hidden', String(!show));
    $('[data-arb-bar-go]', bar).tabIndex = show ? 0 : -1;
  };

  /* ---------------- pick links (hero ticket, reviews) ---------------- */
  function bindPickLinks(scope) {
    $$('[data-arb-pick]', scope || document).forEach(function (a) {
      if (a.__arbPick) return;
      a.__arbPick = true;
      a.addEventListener('click', function (e) {
        var h = a.getAttribute('data-arb-pick');
        var shop = shops.filter(function (s) { return s.byHandle && s.byHandle[h]; })[0];
        if (!shop) return;
        e.preventDefault();
        shop.select(h, { user: true, scroll: true, trigger: a });
      });
    });
  }

  /* ---------------- scroll loop ---------------- */
  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      ticking = false;
      measureTop();
      shops.forEach(function (s) { s.updateBar(); s.updateSticky(); });
    });
  }

  function initShop(el) {
    if (el.__arbShop) return;
    el.__arbShop = new Shop(el);
    shops.push(el.__arbShop);
  }

  function boot() {
    measureTop();
    $$('[data-arb-shop]').forEach(initShop);
    bindPickLinks();
    initReveal();
    shops.forEach(function (s) { s.updateBar(); });
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', function (e) {
    var t = e.target;
    $$('[data-arb-shop]', t).forEach(initShop);
    bindPickLinks(t);
    initReveal(t);
    measureTop();
  });
  document.addEventListener('shopify:section:unload', function (e) {
    shops = shops.filter(function (s) { return !e.target.contains(s.root); });
  });
})();
